import { render, staticRenderFns } from "./TransactionsNFT.vue?vue&type=template&id=703fecf6&scoped=true"
import script from "./TransactionsNFT.vue?vue&type=script&lang=js"
export * from "./TransactionsNFT.vue?vue&type=script&lang=js"
import style0 from "./TransactionsNFT.vue?vue&type=style&index=0&id=703fecf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703fecf6",
  null
  
)

export default component.exports